import React from 'react';

const HealthChecker = () => {
  return (
    <div>
      <a href="/">This is not an empty div</a>
    </div>
  );
};

export default HealthChecker;
